import { usePermissionChecker } from '~/composables/usePermissionChecker'
import NoModuleAccess from '~/pages/general/no-module-access/Index.vue'
import type { NavigationGuardWithThis, RouteLocationNormalized } from 'vue-router'

const moduleGuard: NavigationGuardWithThis<undefined> = (to) => {
  if (checkRequiredModule(to)) {
    return
  }

  to.matched[to.matched.length - 1].components = { default: NoModuleAccess }
}

const checkRequiredModule = (to: RouteLocationNormalized): boolean => {
  const requiredModule = to.meta.requiredCrmModule

  if (!requiredModule) {
    return true
  }

  return usePermissionChecker().canViewEmployeeModule(requiredModule)
}

export default moduleGuard
